import { AuthAction } from "../actions";
// import { Alert } from "react-native"
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
import { UPDATE_PASSWORD } from "../../config/variables";
// import AsyncStorage from '@react-native-community/async-storage';

export default class AuthMiddleware {
  static *SignUp(params) {
    const { payload, cb } = params;
    try {
      let res = yield ApiCaller.Post(
        `logistics_partners`,
        { ...payload },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        localStorage.setItem("companyInfo", JSON.stringify(res.data.data));
        // info("success", res.data.data.message);
        yield put(AuthAction.SignUpSuccess());

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb();
      } else {
        yield put(AuthAction.SignUpFailure());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("error", res.data.error.message);
      }
    } catch (err) {
      yield put(AuthAction.SignUpFailure());
    }
  }

  static *SignOut(params) {
    const { payload, cb } = params;
    const ls = JSON.parse(localStorage.getItem("logistics_Auth"));
    try {
      let res = yield ApiCaller.Post(
        `auth/logout`,
        {},
        {
          Accept: "multipart/form-data",

          "Content-Type": "application/json",
          "x-auth-token": ls.x_auth_token,
        }
      );
      if (res.status == 200) {
        info("success", res.data.data);
        localStorage.removeItem("logistics_Auth");

        yield put(AuthAction.SignoutSuccess());

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb();
      } else {
        // info("error", res.data.error);
        yield put(AuthAction.SignoutFailure());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
      }
    } catch (err) {
      yield put(AuthAction.SignoutFailure());
    }
  }

  static *SignIn(params) {
    const { payload, cb } = params;
    const { isFromRegister, ...rest } = payload;
    const body = {
      ...rest,
    };
    try {
      let res = yield ApiCaller.Post(`authentication/logistics_partners`, body);
      if (res.status == 200) {

        // if (res.data.data[1].logistics_partner.status == 1) {
        //   // console.log("eeeeeeeeee", res.data.data[1]?.logistics_partner.status);
        //   yield put(AuthAction.SignInFailure());
        // }
        // else {

        // info("success", res.data.data.message);

        // replace("Snapshot")
        // console.log("outside if", payload.isFromRegister);

        if (res.data.data[1]?.logistics_partner?.business_name == "null") {

          yield put(AuthAction.SignInSuccess(res.data.data));
          cb && cb(res.data.data);
          localStorage.setItem("logistics_Auth", JSON.stringify(res.data.data));
        }
        if (res.data.data[1].logistics_partner.business_name !== "null") {

          if (res.data.data[1].logistics_partner.status == 1) {
            // console.log("eeeeeeeeee", res.data.data[1]?.logistics_partner.status);
            return yield put(AuthAction.SignInFailure());
          }

          if (!payload.isFromRegister) {

            yield put(AuthAction.SignInSuccess(res.data.data));
            cb && cb(res.data.data);
            // console.log("eeee33eeeeee", res.data.data[1]?.logistics_partner.status);
            // if (res.data.data[1].logistics_partner.status == 1) {
            //   console.log("eeeeeeeeee", res.data.data[1]?.logistics_partner.status);

            //   yield put(AuthAction.SignInFailure());
            // }
            // else {
            localStorage.setItem("logistics_access_token", res.data.access_token);
            localStorage.setItem("logistics_Auth", JSON.stringify(res.data.data));
            // }

          }
        }
        // }




        //
      } else {
        yield put(AuthAction.SignInFailure());

        // if (res.data.data.status == 0) {

        //   // yield put(
        //   //   AuthAction.ForgotPassword({ email: payload.email, cb: callback() })
        //   // );
        //   // callback && callback()
        // }
      }
    } catch (err) {
      yield put(AuthAction.SignInFailure());
    }
  }

  static *VerifyCode(params) {
    const { payload, cb } = params;
    // cb()
    try {
      let res = yield ApiCaller.Post(`auth/verify-code`, payload);
      if (res.status == 200) {
        info("success", res.data.data.message);
        yield put(AuthAction.VerficationCodeSuccess(res.data));
        cb && cb();
        // replace("Snapshot")
      } else {
        info("error", res.data.error.message);
        yield put(AuthAction.VerficationCodeFailure());
        let msg = res["data"]["error"]["message"];
        if (msg == "Unverified email.") {
        } else {
          yield put(AuthAction.VerifyCode());
        }
      }
    } catch (err) {
      yield put(AuthAction.VerficationCodeFailure());
    }
  }

  static *ForgotPassword(params) {
    const { payload, cb } = params;

    try {
      let res = yield ApiCaller.Post(`forgot_password`, payload);
      console.log('response==>', res)
      if (res.status == 200) {
        info('success', 'Your password has been updated!')
        // alert('Success')
        // callback && callback();
        // replace("Snapshot")
        yield put(AuthAction.ForgotPasswordSuccess(res.data));
        cb() && cb();
      } else {
        info("error", res.data.error.message);
        yield put(AuthAction.ForgotPasswordFailure());
        let msg = res["data"]["error"]["message"];
        if (msg == "Unverified email.") {
        } else {
          yield put(AuthAction.ForgotPasswordFailure());
        }
      }
    } catch (err) {
      yield put(AuthAction.ForgotPasswordFailure());
    }
  }

  static *ResetPassword(params) {
    const { payload, cb } = params;
    const { changePassword, ...rest } = payload;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const userId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
      ?.logistics_partner_user?.id;
    try {
      let res = yield (!changePassword ? ApiCaller.Post : ApiCaller.Put)(
        !changePassword
          ? `verification/logistics_partners`
          : `logistics_partners/${companyId}/users/${userId}/change_password`,

        rest
      );
      if (res.status == 200) {
        info("success", `Success`);
        yield put(AuthAction.ResetPasswordSuccess(res.data));
        cb && cb();
      } else {
        info("error", res.data.errors.user_authentication[0]);
        yield put(AuthAction.ResetPasswordFailure());
        let msg = res["data"]["error"]["message"];
        if (msg == "Unverified email.") {
        } else {
          yield put(AuthAction.ResetPasswordFailure());
        }
      }
    } catch (err) {
      yield put(AuthAction.ResetPasswordFailure());
    }
  }

  // static *ResetPassword(params) {
  //   const { payload, cb } = params;
  //   const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
  //     ?.rmx_company?.id;
  //   const userId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
  //     ?.rmx_company_user?.id;
  //   try {
  //     let res = yield ApiCaller.Put(
  //       `rmx_companies/${companyId}/users/${userId}/change_password`,
  //       payload
  //     );
  //     if (res.status == 200) {
  //       info("success", `Success`);
  //       yield put(AuthAction.ResetPasswordSuccess(res.data));
  //       cb && cb();
  //     } else {
  //       info("error", res.data.errors.user_authentication[0]);
  //       yield put(AuthAction.ResetPasswordFailure());
  //       let msg = res["data"]["error"]["message"];
  //       if (msg == "Unverified email.") {
  //         // Alert.alert(
  //         //     "Email Verification",
  //         //     "Your email is not verified, do you want to resend email for verification?",
  //         //     [
  //         //         {
  //         //             text: "Resend",
  //         //             onPress: () => {
  //         //                 Store.dispatch(AuthAction.SendCode({
  //         //                     email: payload.email,
  //         //                     current_time: Functions.currentTime()
  //         //                 }, "SignUpVerify"))
  //         //             },
  //         //             style: "default"
  //         //         },
  //         //         {
  //         //             text: "Cancel",
  //         //             onPress: () => {
  //         //                 Functions.showToast(msg, "danger")
  //         //             },
  //         //             style: "cancel"
  //         //         }
  //         //     ],
  //         //     {
  //         //         cancelable: false
  //         //     }
  //         // )
  //       } else {
  //         yield put(AuthAction.ResetPasswordFailure());
  //       }
  //     }
  //   } catch (err) {
  //     yield put(AuthAction.ResetPasswordFailure());
  //   }
  // }

  static *SocialSignIn(params) {
    const { payload, cb } = params;

    try {
      let res = yield ApiCaller.Post(
        `auth/social`,
        { ...payload, deviceType: "web" },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        info("success", res.data.data.message);
        yield put(AuthAction.SocialSignInSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb(res.data.data);
      } else {
        yield put(AuthAction.SocialSignInError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("%c{res}", "color: red", " => ", res);
      }
    } catch (err) {
      yield put(AuthAction.SocialSignInError());
    }
  }

  static *SocialExtraDetails(params) {
    const { payload, cb } = params;
    const dateOfBirth = payload.dob.split("/").reverse().join("-");

    try {
      let res = yield ApiCaller.Put(
        `auth/social-detail`,
        {
          gender: payload.gender,
          dob: dateOfBirth,
          companyName: payload.companyName,
          role: "event manager",
        },
        {
          "Content-Type": "application/json",
          "x-auth-token": payload.token,
        }
      );
      if (res.status == 200) {
        info("success", res.data.data.message);
        yield put(AuthAction.SocialExtraDetailsSuccess(res.data.data.user));
        localStorage.setItem("logistics_Auth", JSON.stringify(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb();
      } else {
        yield put(AuthAction.SocialExtraDetailsError());
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("%c{res}", "color: red", " => ", res);
      }
    } catch (err) {
      yield put(AuthAction.SocialExtraDetailsError());
    }
  }

  static *updatePassword(params) {
    const { payload, cb, push } = params;

    try {
      let res = yield ApiCaller.Post(
        `${UPDATE_PASSWORD}`,
        { ...payload },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        info("success", res.data.data.message);
        // yield put(AuthAction.SocialSignInSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb();
        push() && push();
      } else {
        cb && cb();

        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("%c{res}", "color: red", " => ", res);
      }
    } catch (err) { }
  }

  static *validationMiddleware(params) {
    const { payload, cb } = params;
    const url = payload.store_url ? "rmx_companies/validation" : "validation";

    try {
      let res = yield ApiCaller.Post(url, {
        ...payload,
        user_type_id: 2,
      });
      if (res.status == 200) {
        // yield put(AuthAction.SocialSignInSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb();
      } else {
        console.log("res==>", res);
        yield put(AuthAction.validationFailure(res.data.errors));
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("%c{res}", "color: red", " => ", res);
      }
    } catch (err) { }
  }

  static *storeUrlMiddleware(params) {
    const { payload, cb } = params;
    const url = `rmx_companies/store/${payload.storeName}`;

    try {
      let res = yield ApiCaller.Get(url, {
        ...payload,
      });
      if (res.status == 200) {
        yield put(AuthAction.getStoreUrlSuccess(res.data.data));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
        cb && cb();
      } else {
        console.log("res==>", res);
        yield put(AuthAction.getStoreUrlFailure(res.data.errors));
        // Functions.showToast(res["data"]["error"]["message"], "danger")
        info("%c{res}", "color: red", " => ", res);
      }
    } catch (err) { }
  }
}
